import { UpdatedSetupSummary } from '../setup/setup.models';
import { PtLuxonDate } from '../projects/date.models';
import { DateTime } from 'luxon';

export class DailyProgressReportSummary {
  updatedSetupSummary: UpdatedSetupSummary;
  vesselName: string;
  clientName: string;
  signatureDate?: DateTime;
}

// Display context passed from the Daily Log for this specific reporting day.
export interface DailyProgressReportContext {
  dateMillis: number;
  summary: DailyProgressReportSummary;
}

export class DailyProgressReportRecord {
  dailyLogRecordId: number;

  sortTime: DateTime;
  displayTime: string;

  comment: string;
  statusText: string;
  operationName: string; // for the dpr, operation name is not actually the operation name - it's something else
  stageName: string; // stage in the grid is equivalent to the operation name in the daily log
  locationText: string;
  logDetailText: string;

  // sorting variables
  ordinal: number; // for whichever lineType the record is
  uniqueOrdinal: number; // unique number for every record in a day, can be switched to change row orders
  operationStartTime: PtLuxonDate;

  // Needs 'archived' variable so that the dpr can use the same 'state' variable for ordering the grid as the daily log - so they will
  // always be in sync in terms of how they are ordered. This will always be set to false for the DPR
  archived: boolean;
}

export class DprSignOffRequest {
  date: DateTime;
  signatureDate: DateTime;
  clientComments: string;
  vesselId: number;
  userId: number;
  isImplementer: boolean;
}



// WEBPACK FOOTER //
// ./src/models/daily-progress-report/daily-progress-report.models.ts